import axios, { AxiosResponse } from "axios";
import { getEnvVar } from "ideas.env";
import { ToolSpecV3 } from "types/json-schemas/ToolSpecV3";
import { getRequestHeaders } from "utils/getRequestHeaders";

type UpdateDraftSpecRequestData = {
  params: ToolSpecV3["params"];
  results: ToolSpecV3["results"];
  resources: ToolSpecV3["resources"];
};

/**
 *  Updates draft spec on tool version through Django backend
 */
export const updateDraftSpec = async (
  toolVersionId: number,
  draftSpec: UpdateDraftSpecRequestData,
) => {
  const headers = await getRequestHeaders();

  const res = await axios.patch<
    { draft_tool_spec: UpdateDraftSpecRequestData },
    AxiosResponse<{
      draft_tool_spec: UpdateDraftSpecRequestData;
      is_draft_spec_synced: boolean | null;
    }>
  >(
    getEnvVar("URL_TRS_TOOL_VERSION_DRAFT_SPEC")(toolVersionId),
    { draft_tool_spec: draftSpec },
    { headers },
  );

  return res.data;
};
